<template>
	<div class="matching--category matching--category--no-y-padding">
		<div class="matching--category-items matching--category-items-no-item-x-padding matching--category-items-center-bar">
			<MatchingItem
				v-for="item in matchingItems"
				:key="item.id"
				:label="item.label"
				:score="item.score"
				:max-score="item.maxScore"
				:clickable="clickable"
				:info-text="item.infoText"
				:with-percentage="withPercentage"
				@click="$emit('click')"
			/>
		</div>
	</div>
</template>
<script>
import MatchingItem from "@/vue/common/matching/Item.vue";
import _ from "lodash";

export default
{
	components: {
		MatchingItem
	},

	props: {
		matching: {
			type: Object,
			required: true
		},
		clickable: {
			type: Boolean,
			required: false,
			default: false
		},
		withPercentage: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	computed: {
		matchingItems ()
		{
			const itemsDesire = _.filter(this.matching.items, item => item.listItemBar === 'desire');
			const itemsExperience = _.filter(this.matching.items, item => item.listItemBar === 'experience');

			return [
				{
					id: 'total',
					label: 'Kann es',
					score: _.sumBy(itemsExperience, 'score'),
					maxScore: _.sumBy(itemsExperience, 'maxScore'),
					infoText: 'Übereinstimmung mit den von dir gewünschten Erfahrungen und Ausbildungen.'
				},
				{
					id: 'pre-filter',
					label: 'Möchte es',
					score: _.sumBy(itemsDesire, 'score'),
					maxScore: _.sumBy(itemsDesire, 'maxScore'),
					infoText: 'Übereinstimmung mit den Wünschen vom Kandidaten.'
				},
			];
		},
	},
}
</script>
